import {useSelector} from "react-redux";

export const useClassNames = (classes = '') => {
    const context = useSelector(state => state.contextState.context);

    let classNames = [
        "sb-root-page",
        classes,
    ];

    for (let contextKey of ['organization', 'parentProgram', 'childProgram', 'project', 'conservationAction']) {
        if (context?.[contextKey]) {
            classNames.push("sb-context-" + contextKey + "-" + context?.[contextKey]);
        }
    }

    return classNames.join(' ');
};
